import { apiClient } from '@/libs/axios';
import type { ApiParamsDefault, ApiResponsePagination } from '@/types/api.type';
import { queryOptions } from '@tanstack/react-query';
import type { Order } from '../types/order.type';

export type GetListOrderParams = Partial<ApiParamsDefault> & {
  user_id?: string;
  type?: string;
  start_date?: string;
  end_date?: string;
};
export type GetListOrderResponse = ApiResponsePagination<Order>;

export const getListOrder = async (
  params?: GetListOrderParams
): Promise<GetListOrderResponse> => {
  const url = 'order';

  return await apiClient.get(url, { params });
};

export const GET_LIST_ORDER_QUERY_KEY = 'list-order';
export function getListOrderQueryOptions(params?: GetListOrderParams) {
  return queryOptions({
    queryKey: [GET_LIST_ORDER_QUERY_KEY, params],
    queryFn: () => getListOrder(params),
  });
}
